module.exports = __webpack_public_path__ + "img/定位-研发基地.9e878f22.svg";